import { callAPi, callAPiMultiPart } from "./api";

const create = (data) => callAPiMultiPart.post("/admin/gallery", data);
const edit = (data, id) => callAPiMultiPart.patch(`/admin/gallery/${id}`, data);
const get = () => callAPi.get("/gallery");
const getAdminAll = () => callAPi.get("/gallery/all");

const getByID = (id) => callAPi.get(`/gallery/${id}`);

const deleteGalleryImage = (id) => callAPi.delete(`/admin/gallery/${id}`);

const gellaryServices = {
  create,
  edit,
  get,
  deleteGalleryImage,
  getByID,
  getAdminAll,
};

export default gellaryServices;
